import React from 'react';

const SvgHealthyLiving = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(25 15)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.96,
  height: 10.4,
  x: 15.6,
  y: 64.48,
  fill: "#BDBDBD",
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M54.907 27.223V42.2c0 15.508-12.292 28.08-27.454 28.08S0 57.707 0 42.2V27.223"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M33.861 54.794a1.324 1.324 0 011.818.477 1.34 1.34 0 01-.474 1.829c-2.205 1.3-4.732 1.947-7.556 1.947-2.812 0-5.412-.641-7.777-1.924a1.34 1.34 0 01-.54-1.81 1.325 1.325 0 011.8-.542c1.973 1.07 4.139 1.604 6.517 1.604 2.365 0 4.428-.529 6.212-1.58zM20.633 46.037a1.059 1.059 0 001.502-.048c.402-.43.38-1.107-.048-1.51-1.453-1.372-3.16-2.072-5.073-2.072-1.9 0-3.648.69-5.205 2.041a1.073 1.073 0 00-.111 1.508 1.059 1.059 0 001.499.111c1.181-1.024 2.441-1.522 3.817-1.522 1.364 0 2.554.488 3.619 1.492zM41.89 46.037a1.059 1.059 0 001.502-.048c.402-.43.38-1.107-.048-1.51-1.453-1.372-3.16-2.072-5.073-2.072-1.9 0-3.648.69-5.205 2.041a1.073 1.073 0 00-.11 1.508 1.059 1.059 0 001.498.111c1.182-1.024 2.441-1.522 3.817-1.522 1.364 0 2.554.488 3.619 1.492zM9.178 23.167C3.546 24.345 0 26.06 0 27.967 0 31.52 12.291 34.4 27.453 34.4c15.162 0 27.454-2.88 27.454-6.432 0-1.648-2.646-3.151-6.997-4.29"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M24.399 27.615c-3.802 2.195-8.811 2.31-11.752-2.784-1.96-3.395-1.943-9.22.052-17.48 4.312 1.62 7.25 2.838 8.813 3.649M34.253 27.615c3.802 2.195 8.81 2.31 11.751-2.784 1.96-3.395 1.943-9.22-.051-17.48-4.312 1.62-7.25 2.837-8.814 3.649"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M29.119 0v28.828h-.045c-5.062-.097-10.046-3.107-10.046-10.29 0-4.82 3.364-10.999 10.09-18.538zm.001 0c6.727 7.54 10.091 13.718 10.091 18.538 0 7.183-4.984 10.193-10.046 10.29h-.045z"
})));

export default SvgHealthyLiving;